import React, {
    useMemo,
} from "react";

const LivePreview = ({
    html = "",
    variables = {},
    employeeNameColor = "#e91e63",
}) => {

    const previewHtml = useMemo(() => {

        let content = html || "";

        Object.entries(
            variables
        ).forEach(([key, value]) => {

            content = content.replaceAll(
                `{{${key}}}`,
                value
            );

        });

        return content.replaceAll(
            "{{employee_name_color}}",
            employeeNameColor
        );

    }, [
        html,
        variables,
        employeeNameColor,
    ]);

    return (

        <div className="card shadow-sm border-0">

            <div className="card-header bg-white py-1 px-2">

                <h6 className="fw-bold mb-0" style={{ fontSize: "13px" }}>

                    Live Preview

                </h6>

            </div>

            <div
                className="card-body bg-light p-2"
                style={{
                    maxHeight: "230px",
                    minHeight: "230px",
                    overflowY: "auto",
                }}
            >

                <div
                    className="bg-white p-2 rounded border h-100"
                    style={{ fontSize: "12px" }}
                    dangerouslySetInnerHTML={{
                        __html: previewHtml,
                    }}
                />

            </div>

        </div>

    );

};

export default LivePreview;